import React from 'react';
import { Text, View, TouchableOpacity, StyleSheet } from 'react-native';

const EonnCheckbox = ({ 
  checked = false, 
  onChange, 
  showRequired = false,
  children,
  label,
  checkboxStyle,
  labelStyle,
  containerStyle
}) => {
  const styles = StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'flex-start',
      maxWidth: '85%',
      width: 500,
      margin: 10,
      marginTop: 15,
    },
    checkbox: {
      width: 20,
      height: 20,
      borderWidth: 1,
      borderColor: (showRequired || checked) ? '#e96556' : '#9597a3',
      borderRadius: 3,
      marginRight: 12,
      marginTop: 2,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: checked ? '#ed3d2a' : '#ffffff',
    },
    checkmark: {
      color: '#ffffff',
      fontSize: 14,
      fontWeight: 'bold',
      lineHeight: 14,
      position: 'relative',
      top: -1,
    },
    labelText: {
      color: '#2e303e',
      fontSize: 16,
      fontFamily: 'nunito',
      lineHeight: 22,
      flex: 1,
      flexWrap: 'wrap',
    },
    errorMessage: {
      backgroundColor: '#e96556',
      color: '#ffffff',
      fontSize: 12,
      paddingTop: 3,
      paddingRight: 14,
      paddingBottom: 4,
      paddingLeft: 14,
      marginTop: 5,
      marginRight: 10,
      marginBottom: 0,
      marginLeft: 32, // Align with the label text
    },
  });

  return (
    <View style={[styles.container, containerStyle]}>
      <TouchableOpacity 
        style={[styles.checkbox, checkboxStyle]}
        onPress={() => onChange?.(!checked)}
        activeOpacity={0.7}
      >
        {checked && <Text style={styles.checkmark}>✓</Text>}
      </TouchableOpacity>
      <TouchableOpacity 
        onPress={() => onChange?.(!checked)}
        activeOpacity={1}
        style={{ flex: 1 }}
      >
        <Text style={[styles.labelText, labelStyle]}>
          {children || label}
        </Text>
      </TouchableOpacity>
      {showRequired && !checked && (
        <View style={{ width: '100%', position: 'absolute', top: '100%' }}>
          <Text style={styles.errorMessage}>This field is required</Text>
        </View>
      )}
    </View>
  );
};

export default EonnCheckbox;